import { Stack, Typography } from "@mui/material";
import type { ReactElement, ReactNode } from "react";

interface Props {
  icon: ReactElement;
  text: string;
  action?: ReactNode;
}

const ArtifactHint = ({ icon, text, action }: Props) => (
  <Stack
    direction="row"
    spacing={1}
    sx={{ alignItems: "center", px: 1.25, py: 0.75, borderRadius: 1.5, bgcolor: "background.grey" }}
  >
    {icon}
    <Typography variant="caption" color="textSecondary" sx={{ flex: 1 }}>
      {text}
    </Typography>
    {action}
  </Stack>
);

export default ArtifactHint;
